/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import i18next from '../../../../../components/Utils/i18next';
import {Chip} from "@mui/material";
import StatusPill from "components/ui/StatusPill";
import Switch from "@mui/material/Switch";
import {formatDate, formatNumber, readableFormatDate, maskSensitiveInfo} from "../../../../../utils";
import { saveAs } from 'file-saver';
import MDBox from "components/MDBox";
import { toast } from "react-hot-toast";
import { Box, Button, Typography } from "@mui/material";
import useApi from "components/Utils/api";
import Tooltip from "@mui/material/Tooltip"

export default function data() {

  return {
    auditTrailcolumns: [
      { Header: "Username", accessor: "userId", width: "10%", align: "left" },
      { Header: i18next.t("auditTrailcolumns.userName"), accessor: "userName", width: "10%", align: "left" },
      { Header: i18next.t("auditTrailcolumns.module"), accessor: "module", width: "10%", align: "left" },
      { Header: i18next.t("auditTrailcolumns.subModule"), accessor: "subModule", width: "10%", align: "left" },
      { Header: i18next.t("auditTrailcolumns.actTime"), accessor: row => formatDate(row.actTime), width: "10%", align: "left" },
      // { Header: i18next.t("auditTrailcolumns.actDesc"), accessor: "actDesc", width: "10%", align: "left" },
      { Header: i18next.t("auditTrailcolumns.reqIp"), accessor: "reqIp", width: "10%", align: "left" },
      { Header: "Role", accessor: "userLevel", width: "10%", align: "left", Cell: ({cell}) => {
        let roleName = ""
          if (cell.value === "MAKER") {
            roleName = "Admin";
          } else if (cell.value === "MERCHANT") {
            roleName = "Merchant User";
          } else if (cell.value === "REFERRALID") {
            roleName = "Organization User";
          } else if (cell.value === "SUPERADMIN") {
            roleName = "Super Admin";
          } else {
            roleName = cell.value;
          }
          return roleName;
        }
      },
      {
        Header: "Summary",
        accessor: "summary",
        width: "10%",
        align: "left",
        Cell: ({ row }) => (
            <button
                onClick={() => {
                  const blob = new Blob([row.original.actDesc], { type: "text/plain;charset=utf-8" });
                  const datatime = new Date().toISOString().replace(/[-:]/g, '').replace('T', '_').replace(/\..+/, '');
                  saveAs(blob, `Summary_${row.original.userId}_${datatime}.txt`);

                }}
            >
              Download
            </button>
        ),
      },
    ],
    transactionSummarycolumns: [
      { Header: i18next.t("transactionSummarycolumns.date"), accessor: row => formatDate(row.date), width: "10%", align: "left" },
      { Header: i18next.t("transactionSummarycolumns.cardAcceptorCode"), accessor: "cardAcceptorCode", width: "10%", align: "left" },
      { Header: i18next.t("transactionSummarycolumns.merchantName"), accessor: "merchantName", width: "10%", align: "left" },
      { Header: i18next.t("transactionSummarycolumns.totalNumOfTrans"), accessor: "totalNumOfTrans", width: "10%", align: "left" },
      { Header: i18next.t("transactionSummarycolumns.currency"), accessor: "currency", width: "10%", align: "left" },
      { Header: i18next.t("transactionSummarycolumns.amount"), accessor: row => formatNumber(row.amount / 100), width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "AUTHORIZED" ? "COMPLETED" : row.status, width: "10%", align: "left" },
      { Header: "Payment Type", accessor: row => row.paymentType === "MER" ? "PURCHASE" : row.paymentType === "REF" ? "REFUND" : row.paymentType, width: "10%", align: "left" },
      { Header: "Settlement Status", accessor: "settlementStatus", width: "10%", align: "left" },
      // { Header: i18next.t("transactionSummarycolumns.merchantId"), accessor: "merchantId", width: "10%", align: "left" },
    ],
    transactionReportcolumns: [
      { Header: i18next.t("transactionReportcolumns.merchantId"), accessor: "merchantId", width: "10%", align: "left" },
      { Header: i18next.t("transactionReportcolumns.terminalId"), accessor: "terminalId", width: "10%", align: "left" },
      { Header: i18next.t("transactionReportcolumns.rrn"), accessor: "rrn", width: "10%", align: "left" },
      { Header: i18next.t("transactionReportcolumns.stan"), accessor: "stan", width: "10%", align: "left" },
      { Header: i18next.t("transactionReportcolumns.transactionAmount"), accessor: row => formatNumber(row.transactionAmount), width: "10%", align: "left" },
      { Header: i18next.t("transactionReportcolumns.type"), accessor: "type", width: "10%", align: "left" },
      { Header: i18next.t("transactionReportcolumns.status"), accessor: "status", width: "10%", align: "left" },
      { Header: i18next.t("transactionReportcolumns.transactionDate"), accessor: row => formatDate(row.transactionDate), width: "10%", align: "left" },
    ],
    userTablecolumns: [
      { Header: i18next.t("userTablecolumns.user_id"), accessor: "userId", width: "10%", align: "left" },
      { Header: i18next.t("userTablecolumns.firstName"), accessor: "firstName", width: "10%", align: "left" },
      { Header: i18next.t("userTablecolumns.lastName"), accessor: "lastName", width: "10%", align: "left" },
      { Header: i18next.t("userTablecolumns.mobileNo"), accessor: "mobileNo", width: "10%", align: "left" },
      { Header: i18next.t("userTablecolumns.emailId"), accessor: "emailId", width: "10%", align: "left" },
      { Header: i18next.t("userTablecolumns.role"), accessor: "role", width: "10%", align: "left" },
      { Header: "Status", accessor: "status", width: "10%", align: "left" },
      { Header: i18next.t("userTablecolumns.action"), accessor: "action", width: "15%", align: "left" },
    ],
    merchantTablecolumns: [
      { Header: i18next.t("merchantTablecolumns.mid"), accessor: "mid", width: "10%", align: "left" },
      { Header: i18next.t("merchantTablecolumns.companyName"), accessor: "companyName", width: "10%", align: "left" },
      { Header: i18next.t("merchantTablecolumns.ownerName"), accessor: "ownerName", width: "10%", align: "left" },
      { Header: i18next.t("merchantTablecolumns.organization"), accessor: "orgName", width: "10%", align: "left" },
      {
        Header: i18next.t("merchantTablecolumns.channels"),
        id: "channels",
        accessor: (row) => [row.gatewayOnboarded && "PG", row.posOnboarded && "POS"].filter(Boolean).join(","),
        Cell: ({ row }) => {
          const { gatewayOnboarded, posOnboarded } = row.original;
          if (!gatewayOnboarded && !posOnboarded) return "-";
          return (
            <MDBox display="flex" gap={0.5} flexWrap="wrap">
              {gatewayOnboarded && <Chip label={i18next.t("payment_gateway")} variant="outlined" color="info" size="small" />}
              {posOnboarded && <Chip label={i18next.t("pos")} variant="outlined" color="success" size="small" />}
            </MDBox>
          );
        },
        width: "12%",
        align: "left",
      },
      { Header: i18next.t("merchantTablecolumns.status"), accessor: "status", Cell: ({cell}) => {
        return cell.value === "1" ? <StatusPill status="ACTIVE" /> : cell.value === "3" ? <StatusPill status="BLOCK" /> : cell.value === "2" ? <StatusPill status="APPROVAL_PENDING" /> : <StatusPill status="IN_ACTIVE" />;
        }, width: "10%", align: "left" },
    ],
    merchantGroupTablecolumns: [
      { Header: i18next.t("merchantGroupTablecolumns.referenceId"), accessor: "referenceId", width: "10%", align: "left" },
      { Header: i18next.t("merchantGroupTablecolumns.referenceCompanyName"), accessor: "referenceCompanyName", width: "10%", align: "left" },
      { Header: i18next.t("merchantGroupTablecolumns.ownerName"), accessor: "ownerName", width: "10%", align: "left" },
      { Header: i18next.t("merchantGroupTablecolumns.status"), accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'In Active', width: "10%", align: "left" },
      { Header: "Is Default", accessor: "isDefault", width: "10%", align: "left", Cell: ({cell}) => {
          return (
              <>
                <Switch
                    checked={cell.value}
                    onChange={() => makeDefault(cell.value)}
                    inputProps={{ 'aria-label': 'controlled' }}
                />
              </>
          );
        }
      },
      { Header: i18next.t("merchantTablecolumns.created_at"), accessor: 'createdDt', Cell: ({cell}) => formatDate(cell.value), width: "10%", align: "left" },
    ],
    terminalTablecolumns: [
      { Header: i18next.t("terminalTablecolumns.name"), accessor: row => row.name || "-", id: "name", width: "18%", align: "left" },
      { Header: i18next.t("terminalTablecolumns.serialNumber"), accessor: row => row.serialNumber || "-", id: "serialNumber", width: "16%", align: "left" },
      { Header: i18next.t("terminalTablecolumns.msisdn"), accessor: "msisdn", width: "16%", align: "left" },
      { Header: i18next.t("terminalTablecolumns.tid"), accessor: "tid", width: "14%", align: "left" },
      { Header: i18next.t("terminalTablecolumns.status"), accessor: "status", Cell: ({cell}) => {
        // Same pill design as the merchant list
        return cell.value === "1" ? <StatusPill status="ACTIVE" /> : cell.value === "3" ? <StatusPill status="BLOCK" /> : <StatusPill status="IN_ACTIVE" />;
        }, width: "12%", align: "left" },
      { Header: i18next.t("terminalTablecolumns.action"), accessor: "action", width: "14%", align: "left" }
    ],
    allTerminalTablecolumns: [
      { Header: i18next.t("allTerminalTablecolumns.mid"), accessor: "mid", width: "10%", align: "left" },
      { Header: i18next.t("allTerminalTablecolumns.msisdn"), accessor: "msisdn", width: "10%", align: "left" },
      { Header: i18next.t("allTerminalTablecolumns.tid"), accessor: "tid", width: "10%", align: "left" },
      { Header: i18next.t("allTerminalTablecolumns.deviceType"), accessor: "deviceType", width: "10%", align: "left" },
      { Header: i18next.t("allTerminalTablecolumns.name"), accessor: "name", width: "10%", align: "left" },
      { Header: i18next.t("allTerminalTablecolumns.status"), accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'In Active', width: "10%", align: "left" },
      { Header: i18next.t("allTerminalTablecolumns.action"), accessor: "action", width: "10%", align: "left" },
    ],
    resetTerminalTablecolumns: [
      { Header: i18next.t("resetTerminalTablecolumns.msisdn"), accessor: "msisdn", width: "10%", align: "left" },
      { Header: i18next.t("resetTerminalTablecolumns.imei"), accessor: "imei", width: "10%", align: "left" },
      { Header: i18next.t("resetTerminalTablecolumns.imsi"), accessor: "imsi", width: "10%", align: "left" },
      { Header: i18next.t("resetTerminalTablecolumns.tid"), accessor: "tid", width: "10%", align: "left" },
      { Header: i18next.t("resetTerminalTablecolumns.deviceType"), accessor: "deviceType", width: "10%", align: "left" },
      { Header: i18next.t("resetTerminalTablecolumns.status"), accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'In Active', width: "10%", align: "left" },
      { Header: i18next.t("resetTerminalTablecolumns.action"), accessor: "action", width: "10%", align: "left" }
    ],
    mposUsersTablecolumns: [
      { Header: i18next.t("mposUsersTablecolumns.userId"), accessor: "userId", width: "10%", align: "left" },
      { Header: i18next.t("mposUsersTablecolumns.firstName"), accessor: "firstName", width: "10%", align: "left" },
      { Header: i18next.t("mposUsersTablecolumns.lastName"), accessor: "lastName", width: "10%", align: "left" },
      { Header: i18next.t("mposUsersTablecolumns.mobileNo"), accessor: "mobileNo", width: "10%", align: "left" },
      { Header: i18next.t("mposUsersTablecolumns.status"), accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'In Active', width: "10%", align: "left" },
      { Header: i18next.t("mposUsersTablecolumns.action"), accessor: "action", width: "10%", align: "left" }
    ],
    merchatnUsersTablecolumns: [
      { Header: i18next.t("merchatnUsersTablecolumns.user_id"), accessor: "userId", width: "10%", align: "left" },
      { Header: i18next.t("merchatnUsersTablecolumns.firstName"), accessor: "firstName", width: "10%", align: "left" },
      { Header: i18next.t("merchatnUsersTablecolumns.lastName"), accessor: "lastName", width: "10%", align: "left" },
      { Header: i18next.t("merchatnUsersTablecolumns.mobileNo"), accessor: "mobileNo", width: "10%", align: "left" },
      { Header: i18next.t("merchatnUsersTablecolumns.emailId"), accessor: "emailId", width: "10%", align: "left" },
      // { Header: "Role", accessor: "authorities[0].authority", Cell: ({cell}) => {
      //   return cell.value === 'REFERRALID' ? "Organization User" : "Merchant User";
      // }, width: "10%", align: "left" },
      { Header: i18next.t("merchatnUsersTablecolumns.action"), accessor: "action", width: "10%", align: "left" },
    ],
    merchantAllUsersTablecolumns: [
      { Header: "Username", accessor: "userId", width: "10%", align: "left" },
      { Header: i18next.t("merchantAllUsersTablecolumns.firstName"), accessor: "firstName", width: "10%", align: "left" },
      { Header: i18next.t("merchantAllUsersTablecolumns.lastName"), accessor: "lastName", width: "10%", align: "left" },
      { Header: i18next.t("merchantAllUsersTablecolumns.mobileNo"), accessor: "mobileNo", width: "10%", align: "left" },
      { Header: i18next.t("merchantAllUsersTablecolumns.emailId"), accessor: "emailId", width: "10%", align: "left" },
      { Header: i18next.t("merchantAllUsersTablecolumns.groupMid"), accessor: "groupMid", width: "10%", align: "left" },
      { Header: i18next.t("merchantTablecolumns.created_at"), accessor: "createdDt", Cell: ({cell}) => formatDate(cell.value), width: "10%", align: "left" },
    ],
    thirtydaysActiveTablecolumns: [
      { Header: i18next.t("thirtydaysActiveTablecolumns.userId"), accessor: "userId", width: "10%", align: "left" },
      { Header: i18next.t("thirtydaysActiveTablecolumns.tid"), accessor: "tid", width: "10%", align: "left" },
      { Header: i18next.t("thirtydaysActiveTablecolumns.fname"), accessor: "fname", width: "10%", align: "left" },
      { Header: i18next.t("thirtydaysActiveTablecolumns.lname"), accessor: "lname", width: "10%", align: "left" },
      { Header: i18next.t("thirtydaysActiveTablecolumns.mobNo"), accessor: "mobNo", width: "10%", align: "left" },
      { Header: i18next.t("thirtydaysActiveTablecolumns.gmid"), accessor: "gmid", width: "10%", align: "left" },
      { Header: i18next.t("thirtydaysActiveTablecolumns.st"), accessor: "st", width: "10%", align: "left" },
      { Header: i18next.t("thirtydaysActiveTablecolumns.ldt"), accessor: "ldt", width: "10%", align: "left" },
    ],
    cashTransactionsReportsColumns: [
      { Header: i18next.t("cashTransactionsReportsColumns.merchantId"), accessor: "merchantId", width: "10%", align: "left" },
      { Header: i18next.t("cashTransactionsReportsColumns.posId"), accessor: "posId", width: "10%", align: "left" },
      { Header: i18next.t("cashTransactionsReportsColumns.transactionNumber"), accessor: "transactionNumber", width: "10%", align: "left" },
      { Header: i18next.t("cashTransactionsReportsColumns.retrievalreferencenumber"), accessor: "retrievalreferencenumber", width: "10%", align: "left" },
      { Header: i18next.t("cashTransactionsReportsColumns.username"), accessor: "username", width: "10%", align: "left" },
      { Header: i18next.t("cashTransactionsReportsColumns.txamount"), accessor: row => formatNumber(row.txamount), width: "10%", align: "left" },
      { Header: i18next.t("cashTransactionsReportsColumns.transactionType"), accessor: "transactionType", width: "10%", align: "left" },
      { Header: i18next.t("cashTransactionsReportsColumns.transactionDate"), accessor: "transactionDate", width: "10%", align: "left" },
      { Header: i18next.t("cashTransactionsReportsColumns.statusDesc"), accessor: "statusDesc", width: "10%", align: "left" },
      { Header: i18next.t("cashTransactionsReportsColumns.reason"), accessor: "reason", width: "10%", align: "left" },
    ],
    cardTransactionsReportsColumns: [
      { Header: i18next.t("cardTransactionsReportsColumns.createdTime"), accessor: 'createdTime', width: "10%", align: "left" },
      { Header: "Merchant Id", accessor: 'merchant.cardAcceptorCode', width: "10%", align: "left" },
      { Header: "Merchant Name", accessor: 'merchant.cardAcceptorName', width: "10%", align: "left" },
      { Header: i18next.t("cardTransactionsReportsColumns.amountInCents"), accessor: row => formatNumber(row.amountInCents / 100), width: "10%", align: "left" },
      { Header: i18next.t("cardTransactionsReportsColumns.currency"), accessor: "currency", width: "10%", align: "left" },
      {
        Header: "Status",
        accessor: row => row.status,
        width: "8%",
        align: "left",
        Cell: ({ value }) => {
          const STATUS_COLORS = {
            INITIATED:            { bg: "#e2e3e5", color: "#383d41" },
            AUTHORIZED:           { bg: "#d4edda", color: "#155724" },
            CAPTURED:             { bg: "#cce5ff", color: "#004085" },
            FAILED:               { bg: "#f8d7da", color: "#721c24" },
            COMPLETED:            { bg: "#c3e6cb", color: "#1e7e34" },
            SETTLEMENT_INITIATED: { bg: "#d1ecf1", color: "#0c5460" },
            SETTLED:              { bg: "#bee5eb", color: "#0c5460" },
            VOID:                 { bg: "#fff3cd", color: "#856404" },
            VOID_UNSUCCESSFULL:   { bg: "#f5c6cb", color: "#721c24" },
          };
          const s = STATUS_COLORS[value] ?? { bg: "#e2e3e5", color: "#383d41" };
          return (
            <MDBox sx={{ display: "inline-block", px: 1.5, py: 0.4, borderRadius: "8px", backgroundColor: s.bg, color: s.color, fontWeight: "500", fontSize: "0.75rem", whiteSpace: "nowrap" }}>
              {value == "AUTHORIZED" ? "APPROVED" : value}
            </MDBox>
          );
        },
      },
      {
        Header: "Settlement Status",
        accessor: row => row.settlementStatus === "SETTLED" ? "SETTLED" : "PENDING",
        width: "8%",
        align: "left",
        Cell: ({ value }) => {
          const SETTLEMENT_STATUS_COLORS = {
            SETTLED: { bg: "#bee5eb", color: "#0c5460" },
            PENDING: { bg: "#fff3cd", color: "#856404" },
          };
          const s = SETTLEMENT_STATUS_COLORS[value];
          return (
            <MDBox sx={{ display: "inline-block", px: 1.5, py: 0.4, borderRadius: "8px", backgroundColor: s.bg, color: s.color, fontWeight: "500", fontSize: "0.75rem", whiteSpace: "nowrap" }}>
              {value}
            </MDBox>
          );
        },
      },
      {
        Header: "Failure Reason",
        accessor: row => row.statusDescription || "—",
        width: "12%",
        align: "left",
        Cell: ({ row }) => {
          if (row.original.status === "FAILED" && row.original.statusDescription) {
            return (
              <Tooltip title={row.original.statusDescription} placement="top">
                <span style={{ maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "inline-block", color: "#721c24", fontWeight: "500" }}>
                  {row.original.statusDescription}
                </span>
              </Tooltip>
            );
          }
          return <span>—</span>;
        },
      },
      { Header: i18next.t("cardTransactionsReportsColumns.isQrPayment"), accessor: row => row.isQrPayment ? 'Yes' : 'No', width: "10%", align: "left" },
      { Header: i18next.t("cardTransactionsReportsColumns.paymentMethodType"), accessor: "paymentMethodType", width: "10%", align: "left" },
      { Header: "Payment Type", accessor: row => row.paymentType === "MER" ? "PURCHASE" : row.paymentType === "REF" ? "REFUND" : row.paymentType, width: "10%", align: "left" },
      {
        Header: "Merchant TXN Id",
        accessor: row => row.paymentType === "REF" ? row.wallet?.walletTransactionId : row.referenceId,
        width: "10%",
        align: "left"
      },
      { Header: "Processor TXN Id", accessor: "processorTransactionId", width: "10%", align: "left" },
      { Header: "Refund Reference", accessor: "refundReference", width: "10%", align: "left" },
      { Header: "Payer IP", accessor: row => row.ipAddress || "-", width: "10%", align: "left" },
      // { Header: i18next.t("cardTransactionsReportsColumns.description"), accessor: "description", width: "10%", align: "left" },
      // { Header: i18next.t("cardTransactionsReportsColumns.merchantId"), accessor: "merchantId", width: "10%", align: "left" },
      // { Header: i18next.t("cardTransactionsReportsColumns.paymentId"), accessor: "paymentId", width: "10%", align: "left" },

    ],
    emailTablecolumns: [
      { Header: i18next.t("emailTablecolumns.emailid"), accessor: "emailid", width: "20%", align: "left" },
      { Header: i18next.t("emailTablecolumns.maildate"), accessor: row => formatDate(row.maildate), width: "20%", align: "left" },
      { Header: i18next.t("emailTablecolumns.email"), accessor: row => maskSensitiveInfo(row.email), width: "50%", align: "left", cell: ({cell}) => (
        <span title={cell.value}>{cell.value}</span>
      ) },
      { Header: i18next.t("emailTablecolumns.response"), accessor: "response", width: "10%", align: "left" }
    ],
    smsTablecolumns: [
      { Header: i18next.t("smsTablecolumns.mobileNo"), accessor: "mobileNo", width: "10%", align: "left" },
      { Header: i18next.t("smsTablecolumns.otpDate"), accessor: row => formatDate(row.otpDate), width: "10%", align: "left" },
      { Header: i18next.t("smsTablecolumns.sms"), accessor: row => maskSensitiveInfo(row.sms), width: "10%", align: "left", cell: ({cell}) => (<div style={{ whiteSpace: 'pre-wrap' }}>{cell.value}</div>) },
      { Header: i18next.t("smsTablecolumns.status"), accessor: row => row.status === "1" ? 'Sent': 'Not Sent', width: "10%", align: "left" }
    ],
    onboardingFilesTableColumns: [
      { Header: i18next.t("onboardingFilesTableColumns.mbfFileName"), accessor: "mbfFileName", width: "10%", align: "left" },
      { Header: i18next.t("onboardingFilesTableColumns.mbfTotalRecords"), accessor: "mbfTotalRecords", width: "10%", align: "left" },
      { Header: i18next.t("onboardingFilesTableColumns.brfFileName"), accessor: "", width: "10%", align: "left" },
      { Header: i18next.t("onboardingFilesTableColumns.brfTotalRecords"), accessor: "brfTotalRecords", width: "10%", align: "left" },
      { Header: i18next.t("onboardingFilesTableColumns.totalProcessedRecords"), accessor: "totalProcessedRecords", width: "10%", align: "left" }
    ],
    setllementBatchesColumns: [
      { Header: "Batch No", accessor: "batchId", width: "10%", align: "left" },
      { Header: i18next.t("setllementBatchesColumns.date"), accessor: row => formatDate(row.date), width: "10%", align: "left" },
      { Header: i18next.t("setllementBatchesColumns.status"), accessor: "status", width: "10%", align: "left" },
      { Header: i18next.t("setllementBatchesColumns.action"), accessor: "action", width: "10%", align: "left" },
    ],
    cardSettlementSummaryTableColumns: [
      { headerName: i18next.t("cardSettlementSummaryTableColumns.cardAcceptorCode"), field: "cardAcceptorCode", flex: 1, align: "left", minWidth: 200 },
      { headerName: "Account No", field: "beneficiaryAccount", flex: 1, align: "left", minWidth: 150 },
      { headerName: i18next.t("cardSettlementSummaryTableColumns.merchantName"), field: "merchantName", flex: 1, align: "left", minWidth: 150 },
      { headerName: i18next.t("cardSettlementSummaryTableColumns.totalNumberOfTransactions"), field: "totalNumberOfTransactions", flex: 1, align: "left", minWidth: 150 },
      { headerName: i18next.t("cardSettlementSummaryTableColumns.transactionAmount"), field: "transactionAmount", valueGetter: params => {
          return formatNumber(params)
          // console.log(params);
        // return 0;
      }, flex: 1, align: "left", minWidth: 150 },
      { headerName: i18next.t("cardSettlementSummaryTableColumns.issuerFee"), field: "issuerFee", valueGetter: params => formatNumber(params), flex: 1, align: "left", minWidth: 150 },
      { headerName: i18next.t("cardSettlementSummaryTableColumns.bankFee"), field: "bankFee", valueGetter: params => formatNumber(params), flex: 1, align: "left", minWidth: 150 },
      { headerName: i18next.t("cardSettlementSummaryTableColumns.settlementFee"), field: "settlementFee", valueGetter: params => formatNumber(params ), flex: 1, align: "left", minWidth: 150 },
      { headerName: i18next.t("cardSettlementSummaryTableColumns.settlementAmount"), field: "settlementAmount", valueGetter: params => formatNumber(params), flex: 1, align: "left", minWidth: 150 },
      { headerName: i18next.t("cardSettlementSummaryTableColumns.currency"), field: "currency", flex: 1, align: "left", minWidth: 100 },
      { headerName: "Source", field: "source", flex: 1, align: "left", minWidth: 100 },
      { 
        headerName: i18next.t("cardSettlementSummaryTableColumns.status"), 
        field: "settlementStatus", 
        renderCell: params => {
          let val = "";
          if (params.row.settlementStatus === "SETTLEMENT_INITIATED") {
            val = <StatusPill status="SETTLEMENT_INITIATED" label="Initiated" />;
          } else if (params.row.settlementStatus === "PENDING" ) {
            val = <StatusPill status="PENDING" />;
          } else if (params.row.settlementStatus === "FAILED" ) {
            val = <StatusPill status="FAILED" />;
          } else if (params.row.settlementStatus === "SETTLED" ) {
            val = <StatusPill status="SETTLED" />;
          }
          return val;
        },
        flex: 1, 
        align: "left", 
        minWidth: 150 
      },
      {
        headerName: "Batch No",
        field: "batchNo",
        flex: 1,
        align: "left",
        minWidth: 200
      },
      // { headerName: i18next.t("cardSettlementSummaryTableColumns.merchantId"), field: "merchantId", flex: 1, align: "left", minWidth: 320 },
      // { headerName: "Action", field: "action", flex: 1, align: "left", renderCell: (params) => params.row.action },
    ],
    mdrMasterTableColumns: [
      { Header: i18next.t("mdrMasterTableColumns.mid"), accessor: "mid", width: "10%", align: "left" },
      { Header: i18next.t("mdrMasterTableColumns.companyName"), accessor: "companyName", width: "10%", align: "left" },
      { Header: i18next.t("mdrMasterTableColumns.cardHoldercharger"), accessor: "cardHoldercharger", width: "10%", align: "left" },
      { Header: i18next.t("mdrMasterTableColumns.merchantMDr"), accessor: "merchantMDr", width: "10%", align: "left" },
      // { Header: "Status", accessor: row => row.status === '0' || row.status === '2' ? 'In Active' : 'Active', width: "10%", align: "left" },
      { Header: i18next.t("mdrMasterTableColumns.action"), accessor: "action", width: "10%", align: "left" },
    ],
    binMasterTableColumns: [
      { Header: i18next.t("binMasterTableColumns.binCode"), accessor: "binCode", width: "10%", align: "left" },
      { Header: i18next.t("binMasterTableColumns.bankMaster.bankName"), accessor: row => row.bankMaster.bankName, width: "10%", align: "left" },
      { Header: i18next.t("binMasterTableColumns.cardTypeMaster.typeName"), accessor: row => row.cardTypeMaster.typeName, width: "10%", align: "left" },
      { Header: i18next.t("binMasterTableColumns.productTypeMaster.typeName"), accessor: row => row.productTypeMaster.typeName, width: "10%", align: "left" },
      { Header: i18next.t("binMasterTableColumns.action"), accessor: "action", width: "10%", align: "left" },
    ],
    posTransactionReportsColumns: [
      { Header: i18next.t("posTransactionReportsColumns.transactionDate"), accessor: row => row[0].transactionDate, width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.pan"), accessor: row => row[0].pan, width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.deviceType"), accessor:row => row[2].deviceType, width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.merchantId"), accessor: row => row[0].merchantId, width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.posId"), accessor: row => row[0].posId, width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.amount"), accessor: row => row[0].amount === null ? '00.000' : formatNumber(row[0].amount), width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.retrievalreferencenumber"), accessor: row => row[0].retrievalreferencenumber, width: "10%", align: "left" },
      // { Header: "Card Holder Surcharge (%)", accessor:row => row[0].cardSurchagePercentage, width: "10%", align: "left" },
      // { Header: "Card Holder Surcharge Amount", accessor:row => row[0].cardSurchageAmount, width: "10%", align: "left" },
      // { Header: "Merchant Service Fee (%)", accessor: row => row[0].msfPercentage, width: "10%", align: "left" },
      // { Header: "Merchant Service Fee Amount", accessor: row => row[0].msfAmount, width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.mobileRefNo"), accessor: row => row[0].mobileRefNo, width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.companyName"), accessor: row => row[1].companyName, width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.responsecode"), accessor: row => row[0].responsecode, width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.status"), accessor: row => row[0].responsecode === "00" ? 'Success' : 'Fail', width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.reversal_status"), accessor: row => row[0].status === '01' ? 'Void Transaction' : '', width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.refund_status"), accessor: row => row[0].status === '02' ? 'Refund Transaction' : '', width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.appName"), accessor: row => row[0].authid, width: "10%", align: "left" },
      // { Header: "Invoice No", accessor: row => row.invoiceNo, width: "10%", align: "left" },
      { Header: i18next.t("posTransactionReportsColumns.appName"), accessor: row => row[0].appName, width: "10%", align: "left" },
    ],
    settlementReportsColumns: [
      { Header: i18next.t("settlementReportsColumns.transactionDate"), accessor: row => row[0].transactionDate, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.pan"), accessor: row => row[0].pan, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.retrievalreferencenumber"), accessor: row => row[0].retrievalreferencenumber, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.merchantId"), accessor: row => row[0].merchantId, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.posId"), accessor: row => row[0].posId, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.amount"), accessor: row => row[0].amount === null ? '00.000' : formatNumber(row[0].amount), width: "10%", align: "left" },
      // { Header: "Issuer Name", accessor: row => row[0].issuerName, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.companyName"), accessor: row => row[1].companyName, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.accountNo"), accessor: row => row[1].accountNo, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.bankName"), accessor: row => row[1].bankName, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.cardSurchagePercentage"), accessor: row => row[0].cardSurchagePercentage, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.cardSurchageAmount"), accessor: row => formatNumber(row[0].cardSurchageAmount), width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.msfPercentage"), accessor: row => row[0].msfPercentage, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.msfAmount"), accessor: row => formatNumber(row[0].msfAmount), width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.merchantSettlementAmount"), accessor: row => formatNumber(row[0].merchantSettlementAmount), width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.posMachineType"), accessor: row => row[1].posMachineType, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.appName"), accessor: row => row[0].appName, width: "10%", align: "left" },
      // { Header: "Branch Name", accessor: row => row[1].bankerBranchName, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.responsecode"), accessor: row => row[0].responsecode === '00' ? 'Success' : 'Fail', width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.reversal_status"), accessor: row => row[0].status === "01" ? 'Void Transaction' : '', width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.authid"), accessor: row => row[0].authid, width: "10%", align: "left" },
      { Header: i18next.t("settlementReportsColumns.invoiceNo"), accessor: row => row[0].invoiceNo, width: "10%", align: "left" },
    ],
    deviceTableColumns: [
      { Header: i18next.t("deviceTableColumns.name"), accessor: "deviceName", width: "18%", align: "left" },
      { Header: i18next.t("deviceTableColumns.type"), accessor: "deviceType", width: "12%", align: "left" },
      { Header: i18next.t("deviceTableColumns.serialNumber"), accessor: "serialNumber", width: "16%", align: "left" },
      {
        Header: i18next.t("deviceTableColumns.status"),
        accessor: "status",
        width: "10%",
        align: "center",
        Cell: ({ cell }) =>
          cell.value === "ACTIVE" ? (
            <Chip label={i18next.t("active")} variant="outlined" color="success" size="small" />
          ) : (
            <Chip label={i18next.t("inactive")} variant="outlined" color="default" size="small" />
          ),
      },
      {
        Header: i18next.t("deviceTableColumns.mapping"),
        accessor: (row) => (row.mapped ? `${row.mid} / ${row.tid}` : i18next.t("devicePage.notMapped")),
        id: "mapping",
        width: "20%",
        align: "left",
      },
      { Header: i18next.t("deviceTableColumns.action"), accessor: "action", width: "8%", align: "left" },
    ],
    processorTableColumns: [
      { Header: i18next.t("processorTableColumns.processorType"), accessor: "processorType", width: "12%", align: "left" },
      { Header: i18next.t("processorTableColumns.category"), accessor: "processorCategory", width: "10%", align: "left" },
      { Header: i18next.t("processorTableColumns.currencies"), accessor: "supportedCurrencies", width: "10%", align: "left" },
      {
        Header: i18next.t("processorTableColumns.directCharge"),
        accessor: "supportsDirectCharge",
        width: "10%",
        align: "center",
        Cell: ({ cell }) =>
          cell.value ? (
            <Chip label="Yes" variant="outlined" color="success" size="small" />
          ) : (
            <Chip label="No" variant="outlined" color="default" size="small" />
          ),
      },
      {
        Header: i18next.t("processorTableColumns.sessionCharge"),
        accessor: "supportsSessionCharge",
        width: "10%",
        align: "center",
        Cell: ({ cell }) =>
          cell.value ? (
            <Chip label="Yes" variant="outlined" color="success" size="small" />
          ) : (
            <Chip label="No" variant="outlined" color="default" size="small" />
          ),
      },
      {
        Header: i18next.t("processorTableColumns.threeDS"),
        accessor: "supports3DS",
        width: "8%",
        align: "center",
        Cell: ({ cell }) =>
          cell.value ? (
            <Chip label="Yes" variant="outlined" color="success" size="small" />
          ) : (
            <Chip label="No" variant="outlined" color="default" size="small" />
          ),
      },
      {
        Header: i18next.t("processorTableColumns.status"),
        accessor: "active",
        width: "8%",
        align: "center",
        Cell: ({ cell }) =>
          cell.value ? (
            <StatusPill status="ACTIVE" size="small" />
          ) : (
            <StatusPill status="FAILED" label="Inactive" size="small" />
          ),
      },
      {
        Header: i18next.t("processorTableColumns.created"),
        accessor: row => readableFormatDate(row.createdDate),
        width: "12%",
        align: "left",
      },
      {
        Header: i18next.t("processorTableColumns.lastUpdated"),
        accessor: row => readableFormatDate(row.updatedDate),
        width: "12%",
        align: "left",
      },
      {
        Header: i18next.t("processorTableColumns.action"),
        accessor: "action",
        width: "10%",
        align: "center",
      },
    ],
    ruleTableColumns: [
      { Header: i18next.t("ruleTableColumns.ruleID"), accessor: "ruleID", width: "10%", align: "left" },
      { Header: i18next.t("ruleTableColumns.conditionField"), accessor: rule => 'IF '+rule.conditionField.toUpperCase()+' IS '+ (rule.conditionOperator.toUpperCase() === 'BETWEEN' ? ' FROM '+rule.conditionFromValue+' TO '+rule.conditionToValue  : rule.conditionFromValue)
          +' THEN ACQUIRER IS '+rule.acquirer.name, width: "10%", align: "left" },
      { Header: i18next.t("ruleTableColumns.action"), accessor: "action", width: "10%", align: "left" }
    ],
  };
}
